import { CircularProgress } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  reInitiateTransaction,
  showPurchaseConfirmationReinitiate,
} from "../../../store/actions";
import { PURCHASE } from "../../../store/types";
import { DetailsGroup } from "./newPurchaseConfirm";
import { CustomizedDialogsforReintitate } from "../customModal";
import CustomLoader from "../../forms/Loader";

class ReinitiateConfirm extends Component {
  constructor(props) {
    super(props);
    const locState = !!this.props.location
      ? this.props.location.state
      : this.props.transaction;
    this.standalone = this.props.standalone || true;
    this.transaction =
      this.props.transaction || (locState && locState.transaction) || {};
    // this.transaction = this.props.transaction || {}

    this.state = {
      confirmationData: this.transaction, //sample_additional_purchase,//null,
      loading: false,
      saving: false,
      success: false,
      open: true,
      modal_open: true,
      ReferenceNO: "",
      isLoading: false,
    };
  }

  async fetchConfirmationData(transaction) {
    const fund =
      transaction.fund_code || transaction.fund || transaction.td_fund;
    const ihno = transaction.Refno || transaction.ihno || transaction.td_ihno;

    const confirmationParams = {
      //   ModuleName: "Webile",
      //   Trtype: "STP",
      ModuleName: "Webile",

      //   Trtype: transaction.trtype,

      //   Refno:  ihno,
      // ihno,
      // fund,

      Ihno: ihno,
      Fund: fund,

      // Trtype: 'STP',
      //   Refno: transaction.ihno,
      // i_ihno: transaction.ihno,
    };
    try {
      //   fetchTempConfirmData({fund,ihno})
      //   return
      this.setState({ loading: true });
      const confirmationResponse =
        await this.props.showPurchaseConfirmationReinitiate(confirmationParams);
      const dtData = confirmationResponse && confirmationResponse.Dtinformation;
      const conData = dtData && dtData[0];

      if (conData) {
        this.setState({ confirmationData: conData });
      }
      this.setState({ loading: false });
      if (!conData) {
        this.setState({
          open: false,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    this.fetchConfirmationData(this.transaction); // Will be used once the API is ready
  }

  async confirmReinitiation() {
    try {
      // console.log('re-initiating!')

      const transaction = this.transaction;
      // console.log(transaction)

      const ihno = transaction.ihno || transaction.td_ihno;
      const reInitiateProps = {
        // Trtype: ' ',

        ihno,
        fund: transaction.fund_code || transaction.fund || transaction.td_fund,
        Invdistflag: "W",
      };

      if (!ihno) {
        return alert("Cannot proceed because IHNO is missing!");
      }

      this.setState({ saving: true });

      const txn = await this.props.reInitiateTransaction(reInitiateProps);
      // alert('Re-initiated transaction!')
      this.setState({
        ReferenceNO: txn.Table1[0].appno,
      });

      this.setState({ success: true, modal_open: true });

      // const onClose = this.props.onClose
      // if(onClose){onClose()}

      // console.log('Re-initiated!!!')
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ saving: false });
    }
  }
  closeModal = () => {
    this.setState({
      modal_open: !this.state.modal_open,
    });
  };
  confirmation = () => {
    this.props.history.push("/dashboard");
  };
  render() {
    const transaction = this.transaction || {};

    const confirmationDataNotFetched =
      Object.keys(this.props.confirmationData || {}).length == 0;

    let confirmationData = this.props.confirmationData;
    if (confirmationDataNotFetched) {
      confirmationData = transaction;
    }
    confirmationData = { ...confirmationData, ...transaction };

    // trSchema = transactionTypes.additional_purchase

    // console.log('transaction type = ')
    // console.log(transaction)

    const transactionSchema = getTransactionSchema(transaction);
    const { fields: schemaFields, name: transactionTypeDesc } =
      transactionSchema;

    // console.log(transactionSchema)

    const transactionFields = confirmationDataNotFetched
      ? fallbackFields
      : schemaFields;

    // Add extra fields for now
    // transactionFields['Fund'] = {label:'AMC',altKeys:['FundDesc','fund']}

    const rawFields = Object.keys(transactionFields).map((k) => {
      const field = transactionFields[k];
      return {
        key: k,
        name: field.label,
        label: field.label,
        ...field,
      };
    });

    const getFieldValue = (field) => {
      let value = confirmationData[field.key];

      const altKeys =
        [...(field.altKeys || []), ...(altKeyMap[field.key] || [])] || [];
      // console.log(`key = ${field.key}`)
      // console.log(confirmationData)
      // console.log(altKeys)
      for (let key of altKeys) {
        if (value) {
          break;
        }
        value = confirmationData[key];
      }

      return value || "--";
    };

    const fields = [];
    for (let f of rawFields) {
      // Showing only values that are not null.
      const value = getFieldValue(f);
      if (value && value != "--") {
        fields.push(f);
        if (f.isDoubleCol) {
          fields.push(null);
        }
      }
    }

    const rows = [];

    const numRows = Math.ceil(fields.length / 2);
    for (let i = 0; i < numRows; i++) {
      const field1 = fields[i * 2];
      const field2 = fields[i * 2 + 1];

      rows.push({ field1, field2 });
      // const isDoubleCol = field1 && field1.isDoubleCol
      // if(isDoubleCol && field2){
      // }
    }
    // console.log(Object.keys(transactionFields))
    // console.log(rawFields,fields,rows)

    // Add fields that aren't there
    if (!confirmationData.arnCode) {
      confirmationData.arnCode = (this.props.arnCode || "").split("-")[1] || "";
    }
    // console.log(this.state.confirmationData)
    return (
      <div
        className="table_border"
        style={{
          margin: "32px 48px",
        }}
      >
        <div
          className="container-fluid d-flex flex-column shadow-sm bg-white rounded"
          style={{
            minHeight: "240px",
            padding: this.standalone ? "24px 36px" : "12px",
            // margin:'0 48px'
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-primary mb-0" style={{ fontSize: 14 }}>
              Confirm re-initiation of transaction{" "}
              {transactionTypeDesc ? `(${transactionTypeDesc})` : ""}
            </p>

            {!this.standalone && (
              <div
                onClick={() => this.props.onClose && this.props.onClose()}
                className={`mouse-pointer`}
              >
                <Close />
              </div>
            )}
          </div>

          {this.state.loading ? (
            <CircularProgress className="m-auto" />
          ) : (
            // <p className=" m-auto" style={{ fontSize: '16px', color: '#6c6c6c' }}>
            //     Transaction re-initiated successfully with the Reference No:{!!this.state.ReferenceNO?this.state.ReferenceNO:""}
            // </p>

            <Fragment>
              {this.state.open &&
                rows.map((r) => {
                  const { field1, field2 } = r;
                  return (
                    <DetailsGroup
                      mainLabel={field1 && field1.label}
                      subLabel={field1 && field1.key && getFieldValue(field1)}
                      mainLabel1={field2 && field2.label}
                      subLabel2={field2 && field2.key && getFieldValue(field2)}
                    />
                  );
                })}
              {this.state.open && (
                <div
                  className="d-flex justify-content-center mt-4 mb-6 MuiTableCell-root table-cell"
                  style={{ border: "none", padding: "4px" }}
                  onClick={() => this.confirmReinitiation()}
                >
                  <div
                    className="transaction-button mouse-pointer text-uppercase
                                    d-flex align-items-center
                                "
                  >
                    Confirm
                    {this.state.saving && (
                      <CustomLoader display={this.state.saving} />
                    )}
                  </div>
                </div>
              )}

              {/* </div> */}
            </Fragment>
          )}
          {this.state.success && (
            <CustomizedDialogsforReintitate
              open={this.state.modal_open}
              closeModal={this.confirmation}
              componentName={transactionTypeDesc}
              refNo={this.state.ReferenceNO}
              confirmation={this.confirmation}
            />
          )}
        </div>
      </div>
    );
  }
}

const isDoubleCol = true;

const fallbackFields = {
  fund: { label: "AMC", altKeys: ["FundDesc"] },
  SchemeDesc: { label: "Scheme", altKeys: ["scheme"] },
  ARNCode: { label: "ARN Code", altKeys: ["arnCode", "Arn_no"] },

  Mobile: { label: "Phone No", altKeys: ["mobile", "Mobile_no"] },
  i_UntAmtValue: {
    label: "Amount (INR)",
    altKeys: ["td_amt", "amount", "sipamount", "Amount"],
  },
};

// Map alternative keys to the props
const amountKeys = ["Amount"];
const altKeyMap = {
  i_UntAmtValue: amountKeys,
  installmentAmount: amountKeys,
  ARNCode: ["Arn_no"],
  Mobile: ["Mobile_no", "mobile"],
  mobile: ["Mobile_no", "Mobile"],

  i_Acno: ["Folio_no"],
  frequency: ["Frequency"],
  sip_freq: ["Frequency"],
  pan: ["Pan_no"],
};

const firstTwoFields = {
  Name: { label: "Investor Name" },

  Email: { label: "Email Id" },
  Mobile: { label: "Phone No" },
};

const secondTwoFields = {
  Fdesc: { label: "AMC" },
  i_Acno: { label: "Folio" },
};

const firstFourFields = {
  ...firstTwoFields,
  ...secondTwoFields,
};
const firstFiveFields = {
  ...firstFourFields,
  Schdesc: { label: "Scheme", isDoubleCol },
};

const newPurchaseFields = {
  ...firstFiveFields,

  ARNCode: { label: "ARN Code" },
  subarn: { label: "Sub ARN Code" },

  EUINCode: { label: "EUIN No" },
  i_UntAmtValue: { label: "Investment Amount (INR)" },
};

const sipFields = {
  ...firstFiveFields,

  redemptionType: { label: "No of installments" },
  sip_freq: { label: "SIP Frequency" },
  sip_day: { label: "SIP Day" },
  NoOfInstalments:{label:"No Of Installments"},
  sip_strtdate: { label: "Start Date" },
  sip_enddt: { label: "End Date" },
  EUINCode: { label: "EUIN No" },
  i_Fname: { label: "Investor Name" },
  sip_mode: { label: "Mode of registration" },
  i_UntAmtValue: { label: "Lumpsum Investment Amount(INR)" },
  sip_amt: { label: "Installment Payment Amount(INR)" },
  ARNCode: { label: "ARN Code" },
  subarn: { label: "Sub ARN Code" },
};

const redemptionFields = {
  ...firstFiveFields,

  redemptionType: { label: "Redemption Type" },
  redemptionMode: { label: "Redemption Mode" },
  redemptionMode: { label: "Redemption Value(INR/UNITS)" },
  pan: { label: "PAN" },
};

const swpFields = {
  ...firstFiveFields,

  swpOption: { label: "SWP Option" },
  noWithdrawals: { label: "No of withdrawals" },
  frequency: { label: "Frequency" },
  swpDay: { label: "SWP Day" },
  startDate: { label: "Start Date" },
  endDate: { label: "End Date" },
  swpAmount: { label: "SWP Amount(INR)" },
  pan: { label: "PAN" },
};

const switchFields = {
  ...firstFourFields,

  switchOutScheme: { label: "Switch Out Scheme", isDoubleCol },
  switchType: { label: "Switch Type" },
  switchInScheme: { label: "Switch In Scheme" },
  switchMode: { label: "Switch Mode" },
  ARNCode: { label: "ARN Code" },
  subARNCode: { label: "Sub ARN Code" },
  EUINCode: { label: "EUIN No" },
  paymentUnits: { label: "Payment Units" },
};

const stpFields = {
  ...firstFourFields,

  switchOutScheme: { label: "Switch Out Scheme", isDoubleCol },
  stpOption: { label: "STP Option" },
  noTransfers: { label: "No of transfers" },
  frequency: { label: "Frequency" },
  stpDay: { label: "STP Day" },
  startDate: { label: "Start Date" },
  endDate: { label: "End Date" },
  switchInScheme: { label: "Switch In Scheme" },
  installmentAmount: { label: "Installment amount(INR)" },
  pan: { label: "PAN" },
  ARNCode: { label: "ARN Code" },
  subARNCode: { label: "Sub ARN Code" },
  euin: { label: "EUIN No" },
};

const trTypes = ["newPurchase", "sip", "redemption", "stp", "swp", "switch"];

const keyList = {};

const localScope = {
  newPurchaseFields,
  sipFields,
  redemptionFields,
  stpFields,
  switchFields,
  swpFields,
};
for (let ttype of trTypes) {
  const all_keys = localScope[ttype + "Fields"];
  const fieldObj = all_keys;

  keyList[ttype] = Object.keys(fieldObj);
}

// console.log(keyList)
export const transactionTypes = {
  "New purchase": {
    fields: newPurchaseFields,
    keys: ["NEW", "NEW_PURCHASE", "NEWP", "P", "N", "New Purchase", "LTOF"],
  },

  "Additional Purchase": {
    fields: newPurchaseFields,
    keys: ["ADD", "A", "ADDITIONAL_PURCHASE", "Additional Purchase"],
  },
  SIP: {
    fields: sipFields,
    keys: ["SIP", "ISIP", "sini", "SIN"],
  },

  Redemption: {
    fields: redemptionFields,
    keys: ["REDEMPTION", "RED", "FUL", "Redemption", "Fulfill", "Fulfillment"],
  },
  SWP: {
    fields: swpFields,
    keys: ["SWP"],
  },

  Switch: {
    fields: switchFields,
    keys: ["SWITCH", "LTOF", "LTOP", "SWOF", "Switch"],
  },
  STP: {
    fields: stpFields,
    keys: ["STP"],
  },
};

const transactionTypeList = Object.keys(transactionTypes).map((k) => {
  return { ...transactionTypes[k], name: k };
});

function getTransactionSchema(transaction) {
  let trtype = transaction.td_trtype || transaction.trtype;
  // console.log(transaction)
  // console.log('trtype === ')
  // console.log(trtype)
  const schema = transactionTypeList.find(
    (t) => t.keys && t.keys.includes(trtype)
  );

  // console.log(schema)

  return (
    schema || {
      fields: fallbackFields,
      name: "",
    }
  );
}

export default connect(
  ({ transactions, authReducer }) => ({
    arnCode: authReducer.token,
    confirmationData: transactions.confirmationData,
  }),
  {
    showPurchaseConfirmationReinitiate,
    reInitiateTransaction,
  }
)(ReinitiateConfirm);
